module.exports = __webpack_public_path__ + "media/1x1/bl-4d724b8e.svg";